<template>
  <page-header-wrapper>
    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="d-flex change-state">
        <a-range-picker
          :ranges="{
            最近七天: [moment().subtract('days', 6), moment()],
            今天: [moment(), moment()],
            本月: [moment().startOf('month'), moment()]
          }"
          :placeholder="['开始日期', '结束日期']"
          @change="value => handleChangeDate(value)"
        />
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
        <export
          :columns="columns"
          :params="params"
          :url="apiList.getList"
          xlsxName="奖学金计划"
          v-action:export
          @click="getExportData"
        />

      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="skill_area" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="skill_area_extra" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="contact" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="help" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="diffcult" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="join" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="story" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="extra" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>
        <template slot="wish" slot-scope="text">
          <div class="clamp-2">{{ text }}</div>
        </template>

      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table } from '@/mixins' // 引入
import { TableToolBarList, Export } from '@/components'

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '姓名',
        dataIndex: 'name'
    },
    {
        title: '邮箱',
        dataIndex: 'email'
    },
    {
        title: '电话',
        dataIndex: 'phone'
    },
    {
        title: '地区',
        dataIndex: 'area'
    },
    {
        title: '性别',
        dataIndex: 'sex'
    },
    {
        title: '标签',
        dataIndex: 'tags'
    },
    {
        title: '公司',
        dataIndex: 'company'
    },
    {
        title: '技能领域',
        dataIndex: 'skill_area',
        scopedSlots: { customRender: 'skill_area' }
    },
    {
        title: '额外技能领域',
        dataIndex: 'skill_area_extra',
        scopedSlots: { customRender: 'skill_area_extra' }
    },
    {
        title: '与开源联系',
        dataIndex: 'contact',
        scopedSlots: { customRender: 'contact' }
    },
    {
        title: '获得帮助',
        dataIndex: 'help',
        scopedSlots: { customRender: 'help' }
    },
    {
        title: '困难',
        dataIndex: 'diffcult',
        scopedSlots: { customRender: 'diffcult' }
    },
    {
        title: '加入开源',
        dataIndex: 'join',
        scopedSlots: { customRender: 'join' }
    },
    {
        title: '故事',
        dataIndex: 'story',
        scopedSlots: { customRender: 'story' }
    },
    {
        title: '材料',
        dataIndex: 'extra',
        scopedSlots: { customRender: 'extra' }
    },
    {
        title: '项目地址',
        dataIndex: 'link'
    },
    {
        title: '心愿',
        dataIndex: 'wish',
        scopedSlots: { customRender: 'wish' }
    },
    {
        title: '年份',
        dataIndex: 'year'
    },
    {
        title: '创建时间',
        align: 'center',
        dataIndex: 'created_at'
    }
]

const apiList = {
    getList: '/activities/scholarship'
}

export default {
    name: 'ScholarshipList',
    mixins: [ list, table ], // 使用mixins
    components: {
        TableToolBarList,
        Export
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            scroll: {
                x: 2800
            }
        }
    },
    mounted () {
        this.getLists()
    },
    methods: {
        /**
         * 获取打印数据
         * @jdy
         *newColumns,data
         * @2020-11-30
         */
        getExportData (columns, data) {
            this.outputXlsxFile(columns, data, '**奖学金计划列表' + this.moment(new Date()).format('YYYYMMDDHHmmss'))
        }
    }
}
</script>

<style lang="less">
.order-item {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
}
.clamp-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;
}
</style>
